import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Shield, LogIn } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.email || !formData.password) {
      toast.error("Mohon lengkapi email dan password");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API}/auth/login`, formData, {
        withCredentials: true
      });
      
      // Store token in localStorage as backup
      if (response.data.access_token) {
        localStorage.setItem("admin_token", response.data.access_token);
      }
      
      toast.success("Login berhasil!");
      navigate("/admin/dashboard");
    } catch (error) {
      const detail = error.response?.data?.detail;
      let errorMsg = "Email atau password salah";
      
      if (typeof detail === "string") {
        errorMsg = detail;
      } else if (Array.isArray(detail)) {
        errorMsg = detail.map(e => e.msg || JSON.stringify(e)).join(" ");
      }
      
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA] p-4">
      <div className="w-full max-w-md animate-fadeIn">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-[#002FA7] flex items-center justify-center mx-auto mb-4">
            <Shield className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl sm:text-3xl font-black text-[#0A0A0A] mb-2">
            Admin Login
          </h1>
          <p className="text-[#475569]">
            Masuk ke dashboard admin SBW IQ Tester
          </p>
        </div>

        {/* Form */}
        <div className="bg-white border border-slate-200 p-6 md:p-8">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="space-y-2">
              <Label htmlFor="email" className="text-sm font-medium text-[#0A0A0A]">
                Username / Email
              </Label>
              <Input
                id="email"
                name="email"
                type="text"
                placeholder="Username atau email"
                value={formData.email}
                onChange={handleChange}
                className="h-11 border-slate-200 rounded-sm"
                data-testid="admin-email-input"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password" className="text-sm font-medium text-[#0A0A0A]">
                Password
              </Label>
              <Input
                id="password"
                name="password"
                type="password"
                placeholder="••••••••"
                value={formData.password}
                onChange={handleChange}
                className="h-11 border-slate-200 rounded-sm"
                data-testid="admin-password-input"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full h-12 bg-[#002FA7] hover:bg-[#00237C] text-white font-semibold rounded-sm transition-colors"
              data-testid="admin-login-btn"
            >
              {loading ? (
                "Memproses..."
              ) : (
                <>
                  <LogIn className="w-4 h-4 mr-2" />
                  Login
                </>
              )}
            </Button>
          </form>
        </div>

        {/* Back Link */}
        <div className="mt-6 text-center">
          <a 
            href="/" 
            className="text-sm text-[#475569] hover:text-[#002FA7] transition-colors"
            data-testid="link-back-home"
          >
            &larr; Kembali ke Beranda
          </a>
        </div>
      </div>
    </div>
  );
}
